import {
    Action,
    DataContainer,
    Feature,
    MiniAction,
    submitMerge,
    submitMiniAction,
    submitMove,
    trackOnNextPageImpression
} from "@otto-ec/tracking-bct";
import {TrackingFeatureStatus} from "./types";
import {getPagecluster} from "@otto-ec/global-resources/misc";

export class TrackingService {

    sendInitialLoadedTrackingEvent(featureId: string, parentFeatureId: string, featureOrder: number, imageId: string, targetUrl: string, featureIndex: number, masFeatureTrackingLabels: DataContainer) {
        const trackingFeatures = [this.createMediumShopPromoTrackingFeature(parentFeatureId, featureOrder, "loaded", masFeatureTrackingLabels, featureIndex)];
        trackingFeatures.push(this.createMediumShopPromoTileTrackingFeature(featureId, parentFeatureId, "loaded", imageId, targetUrl));
        submitMerge({}, trackingFeatures);
    }

    sendVisibleTrackingEvent(featureId: string, parentFeatureId: string,) {
        const mediumShopPromoFeatureMiniAction = this.createMediumShopPromoFeatureMiniAction(parentFeatureId)
        const mediumShopPromoTileFeatureMiniAction = this.createMediumShopPromoTileFeatureMiniAction(featureId)
        submitMiniAction([mediumShopPromoFeatureMiniAction, mediumShopPromoTileFeatureMiniAction]);
    }

    sendClickTrackingEvent(featureId: string, parentFeatureId: string, featureOrder: number, imageId: string, targetUrl: string, featureIndex: number, masFeatureTrackingLabels: DataContainer, masNextPiTrackingLabels: DataContainer) {
        const featureTrackingData: Action = {
            name: "click",
            features: [
                this.createMediumShopPromoTrackingFeature(parentFeatureId, featureOrder, "clicked", masFeatureTrackingLabels, featureIndex),
                this.createMediumShopPromoTileTrackingFeature(featureId, parentFeatureId, "clicked", imageId, targetUrl)]
        }
        const wkTrackingData: DataContainer = this.createWkTrackingData()
        submitMove(wkTrackingData, featureTrackingData);
        const existingNextPiTrackingLabels = {'promo_Click': ['MediumShopPromo']};
        const nextPiTrackingLabels = {
            ...existingNextPiTrackingLabels,
            ...masNextPiTrackingLabels
        }
        trackOnNextPageImpression(nextPiTrackingLabels);
    }


    private createWkTrackingData(): DataContainer {
        return {
            "wk.promo_AttributionFeature": [`MediumShopPromo_${getPagecluster()}`],
            "wk.promo_AttributionSource": ["manual"],
        }
    }


    private createMediumShopPromoTrackingFeature(parentFeatureId: string, featureOrder: number, status: TrackingFeatureStatus, masFeatureTrackingLabels: DataContainer, featureIndex: number): Feature {
        return {
            id: parentFeatureId,
            name: "MediumShopPromo",
            position: featureOrder,
            status: status,
            labels: {
                ...masFeatureTrackingLabels,
                promo_Feature: ["true"],
                promo_FilledSlots: ["1"],
                promo_FeatureNumber: [(featureIndex + 1).toString()]
            }
        }
    }

    private createMediumShopPromoTileTrackingFeature(featureId: string, parentFeatureId: string, status: TrackingFeatureStatus, imageId: string, featureContent: string): Feature {
        return {
            id: this.getTileFeatureTrackingId(featureId),
            parentId: parentFeatureId,
            position: 1,
            name: "MediumShopPromo-Tile",
            status: status,
            labels: {
                promo_Content: [featureContent],
                promo_TargetPsr: featureContent.includes("?selektion=") ? [featureContent.split("?selektion=")[1]] : [featureContent],
                promo_Source: ["manual"],
                promo_ImageId: [imageId],
            }
        }
    }

    private getTileFeatureTrackingId(featureId: string) {
        return `ft3_msp_${featureId}_tile`;
    }

    private createMediumShopPromoFeatureMiniAction(parentFeatureId: string): MiniAction {
        return {
            featureId: parentFeatureId,
            action: "scroll"
        }
    }

    private createMediumShopPromoTileFeatureMiniAction(featureId: string): MiniAction {
        return {
            featureId: this.getTileFeatureTrackingId(featureId),
            action: "scroll"
        }
    }
}
